module.exports = __webpack_public_path__ + "static/img/14.7665f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/14.png
// module id = 7qTC
// module chunks = 0